<template>
  <v-layout>
    <v-dialog v-model="isVisible" lazy persistent max-width="700px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.native="handleClose">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Close without deleting</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-title class="mb-0 pb-0">
          <h5>
            <v-icon medium color="red">warning</v-icon>
            Delete "{{ item.name }} - {{ item.value }}" ?
          </h5>
        </v-card-title>
        <v-card-text>
          <div class="mb-3">
            <p>
              <strong>
                Are you sure you want to delete this item?
              </strong>
            </p>
            <p>
              The item will not be recoverable after this action.
            </p>
          </div>

          <v-divider></v-divider>
          <v-flex xs12>
            <v-btn @click="handleCancel" class="ml-0">Cancel</v-btn>
            <v-btn
              :loading="isLoading"
              @click="handleDelete"
              type="submit"
              color="error"
            >
              Delete
            </v-btn>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({
        id: undefined,
        name: "Nothing is selected",
        type: undefined,
        value: undefined,
        isOem: undefined,
        customizations: [],
        parents: []
      })
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClose() {
      this.$emit("onClose");
    },
    handleCancel() {
      this.$emit("onCancel");
    },
    handleDelete() {
      this.$emit("onDelete");
    }
  }
};
</script>
